var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"image",on:{"click":function($event){return _vm.prevImage()}}},[_c('img',{attrs:{"src":_vm.src,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }